import { useEffect, useState } from 'react';
import fnc from '../mymod/commFunction';
import './SetupDownloadCountBadge.scss';

const DOWNLOAD_COUNT_LABEL = '\uB2E4\uC6B4\uB85C\uB4DC';
const DOWNLOAD_COUNT_SUFFIX = '\uD68C';
const DOWNLOAD_COUNT_REFRESH_LABEL = '\uC0C8\uB85C\uACE0\uCE68';
const DOWNLOAD_PAGE_KEY = 'setup_download';

const SetupDownloadCountBadge = ({ className = '' }) => {
  const [downloadCount, setDownloadCount] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const setCountFromResponse = (res) => {
    if (res && Array.isArray(res) && res[0]) {
      setDownloadCount(Number(res[0].view_count) || 0);
      return;
    }
    setDownloadCount(0);
  };

  const refreshDownloadCount = () => {
    setIsRefreshing(true);
    fnc.sendAxios('/homePageRoutes/selectViewCount', { pageKey: DOWNLOAD_PAGE_KEY }, (res) => {
      setCountFromResponse(res);
      setIsRefreshing(false);
    });
  };

  useEffect(() => {
    refreshDownloadCount();
  }, []);

  return (
    <div className={`setup-download-count-wrap ${className}`.trim()}>
      <p className="setup-download-count">{DOWNLOAD_COUNT_LABEL} {downloadCount.toLocaleString()}{DOWNLOAD_COUNT_SUFFIX}</p>
      <button
        type="button"
        className={`setup-download-refresh ${isRefreshing ? 'is-refreshing' : ''}`}
        onClick={refreshDownloadCount}
        disabled={isRefreshing}
      >
        {isRefreshing ? `${DOWNLOAD_COUNT_REFRESH_LABEL}...` : DOWNLOAD_COUNT_REFRESH_LABEL}
      </button>
    </div>
  );
};

export default SetupDownloadCountBadge;
